// Shared helpers for lock/read-only zone states.

export const findZoneById = (zones = [], zoneId) => {
  if (zoneId == null || !Array.isArray(zones)) return null;
  return zones.find((zone) => `${zone.id}` === `${zoneId}`) || null;
};

export const isZoneLocked = (zone) => Boolean(zone?.locked);

export const getZoneLockState = ({ zone, forceLocked = false } = {}) => {
  const locked = Boolean(forceLocked) || isZoneLocked(zone);
  return { locked, editable: !locked };
};
